import Navbar from "@/components/Navbar";
import { Link } from "react-router-dom";
import { ArrowLeft, Buildings, MapPin, Envelope, Phone } from "@phosphor-icons/react";

export default function About() {
  return (
    <div className="min-h-screen bg-[#050505]">
      <Navbar />
      <article className="max-w-3xl mx-auto px-4 sm:px-6 py-10 prose-tumusika">
        <Link to="/" className="inline-flex items-center gap-2 text-white/60 hover:text-white text-sm mb-6">
          <ArrowLeft size={16} /> Volver al inicio
        </Link>

        <p className="text-sm uppercase tracking-widest text-[#FFB800] mb-3">Quiénes somos</p>
        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter mb-8">La empresa detrás de Tu MusiKa</h1>

        <div className="rounded-2xl bg-[#121212] border border-white/10 p-6 sm:p-8 space-y-5">
          <div className="flex items-start gap-4">
            <div className="w-11 h-11 rounded-xl bg-[#FFB800]/10 flex items-center justify-center shrink-0">
              <Buildings size={22} weight="duotone" className="text-[#FFB800]" />
            </div>
            <div>
              <p className="text-xs uppercase tracking-widest text-white/40 mb-1">Razón social</p>
              <p className="font-display text-xl font-bold">Marketing de Inteligencia Artificial S. de R.L. de C.V.</p>
            </div>
          </div>

          <div className="flex items-start gap-4">
            <div className="w-11 h-11 rounded-xl bg-[#B4F34A]/10 flex items-center justify-center shrink-0">
              <MapPin size={22} weight="duotone" className="text-[#B4F34A]" />
            </div>
            <div>
              <p className="text-xs uppercase tracking-widest text-white/40 mb-1">Domicilio fiscal</p>
              <p className="text-white/90 leading-relaxed">
                Av. Américas 1545,<br />
                Colonia Providencia,<br />
                Guadalajara, Jalisco, México.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4">
            <div className="w-11 h-11 rounded-xl bg-[#FF4B00]/10 flex items-center justify-center shrink-0">
              <Phone size={22} weight="duotone" className="text-[#FF4B00]" />
            </div>
            <div>
              <p className="text-xs uppercase tracking-widest text-white/40 mb-1">Contacto</p>
              <p className="text-white/90">WhatsApp: <span className="font-mono">+52 33 4280 2102</span></p>
            </div>
          </div>
        </div>

        <h2 className="font-display text-2xl font-bold mt-10 mb-3">Nuestra misión</h2>
        <p className="text-white/70 leading-relaxed">
          Democratizamos la creación musical. Con inteligencia artificial de última generación, cualquier persona puede transformar su historia, sus emociones o sus dedicatorias en una canción personalizada de calidad profesional, sin necesidad de ser músico ni tener equipo de estudio.
        </p>

        <h2 className="font-display text-2xl font-bold mt-8 mb-3">Cómo lo hacemos</h2>
        <p className="text-white/70 leading-relaxed">
          Combinamos modelos avanzados de lenguaje (Anthropic Claude) para escribir las letras y generación de audio musical para producir las canciones. Nuestra plataforma está pensada con enfoque mobile-first para usuarios mexicanos, con métodos de pago locales y géneros culturalmente relevantes.
        </p>

        <h2 className="font-display text-2xl font-bold mt-8 mb-3">Valores</h2>
        <ul className="space-y-2 text-white/70">
          <li>• Respeto a los derechos de autor — cada canción creada pertenece al usuario que la generó.</li>
          <li>• Transparencia en precios — sin cargos ocultos ni suscripciones forzadas.</li>
          <li>• Calidad emocional — cada canción debe contar una historia real con corazón.</li>
          <li>• Orgullo mexicano — desde corridos hasta cumbias, salsa o baladas.</li>
        </ul>

        <div className="mt-10 pt-6 border-t border-white/10 text-sm text-white/40">
          <p>Última actualización: febrero de 2026.</p>
        </div>
      </article>
    </div>
  );
}
